export default __webpack_public_path__ + "static/media/pic3.8ed98018.png";